import Typography from "@mui/material/Typography";
import {Col, Row} from "reactstrap";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";

export default function VatiaCheckoutNavigation(props)
{
    return (
        props.activeStep > 0 ?
            <Row style={{}}>
                <Row style={{width: "100%", maxWidth:500, marginLeft:"auto", marginRight:155}}>
                    <Stepper activeStep={props.activeStep} style={{marginTop: props.width>props.breakpoint ? 30 : 0, marginBottom: 10}}>
                        {props.steps.map((label, index) => (
                            <Step key={label} completed={props.completed[index]}
                                  sx={{
                                      '& .MuiStepLabel-root .Mui-completed': {
                                          color: 'green', // circle color (COMPLETED)
                                      },
                                      '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                                          {
                                              color: 'red', // Just text label (COMPLETED)
                                          },
                                      '& .MuiStepLabel-root .Mui-active': {
                                          color: 'orange', // circle color (ACTIVE)
                                      },
                                      '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
                                          {
                                              color: 'common.white', // Just text label (ACTIVE)
                                          },
                                      '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                                          fill: 'black', // circle's number (ACTIVE)
                                      },
                                      '& .MuiStepIcon-text' :
                                          {
                                              fontSize:12
                                          }
                                  }}
                            >
                                <StepButton color="inherit" onClick={props.handleStep(index)}>
                                    <Typography sx={{ mt: 2, mb: 1, fontSize: 12 }}>
                                        {label}
                                    </Typography>
                                </StepButton>
                            </Step>
                        ))}
                    </Stepper>
                </Row>
            </Row> : null
    )
}